'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _common = require('../../../../common/common.module');

var _common2 = _interopRequireDefault(_common);

require('../../../feiseanna/one');

var _ngRedux = require('ng-redux');

var _ngRedux2 = _interopRequireDefault(_ngRedux);

var _mapStateToController = require('./mapStateToController');

var _mapStateToController2 = _interopRequireDefault(_mapStateToController);

var _index = require('ifeis-isomorphic/lib/redux/actions/schools/index');

var _index2 = require('ifeis-isomorphic/lib/redux/actions/accounts/index');

var _cart = require('ifeis-isomorphic/lib/redux/actions/cart');

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _paymentForm = require('../../../../payment-form');

var _paymentForm2 = _interopRequireDefault(_paymentForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pathToAccountId = function pathToAccountId(pid) {
  return ['persons', 'one', pid, 'acct_id'];
};

var SchoolCompetitorEventsController = function () {
  function SchoolCompetitorEventsController($ngRedux, $stateParams, feis, msgService, $state, metadata, isGod, $scope, fPaymentFormDialog) {
    var _this = this;

    _classCallCheck(this, SchoolCompetitorEventsController);

    this.feis = feis;
    this.$ngRedux = $ngRedux;
    this.$state = $state;
    this.msgService = msgService;
    this.loadingRegistrations = true;
    this.fPaymentFormDialog = fPaymentFormDialog;
    this.loggedinAccountId = $stateParams.loggedinAccountId;
    this.selectedUniqueAccounts = [];
    $ngRedux.dispatch((0, _index.getRegistrations)($stateParams.sid, $stateParams.id)).finally(function () {
      return _this.loadingRegistrations = false;
    });

    $ngRedux.connect((0, _mapStateToController2.default)($stateParams.sid, $stateParams.id, this.feis.credit_card_fee))(this);

    // for dynamic breadcrumbs
    $scope.hasAnyGrantsForFeis = isGod || metadata.grants.length;
    this.hasAnyGrantsForFeis = $scope.hasAnyGrantsForFeis;
  }

  _createClass(SchoolCompetitorEventsController, [{
    key: 'goRegister',
    value: function goRegister(pid) {
      var _this2 = this;

      this.loading = true;
      this.$ngRedux.dispatch((0, _index2.getAccountForPerson)(pid)).then(function () {
        var acctId = _this2.$ngRedux.getState().getIn(pathToAccountId(pid));
        _this2.$state.go('feiseanna.one.register', { feis: _this2.feis, account: acctId });
      }).catch(function (e) {
        return _this2.msgService.displayErrorMsg("Couldn't route to register page. Error occurred : " + e.message);
      }).finally(function () {
        return _this2.loading = false;
      });
    }
  }, {
    key: 'checkFeisStateAndGrants',
    value: function checkFeisStateAndGrants() {
      var now = new Date().getTime();
      return this.feis.dt_reg_start < now && this.feis.dt_reg_end > now || this.hasAnyGrantsForFeis;
    }
  }, {
    key: 'goRegistration',
    value: function goRegistration() {
      this.$state.go('feiseanna.one.admin.registration', { feis: this.feis });
    }
  }, {
    key: 'isCompetitorsLoading',
    value: function isCompetitorsLoading() {
      return this.loading || this.loadingRegistrations;
    }
  }, {
    key: 'submitPayment',
    value: function submitPayment(event) {
      var _this3 = this;

      this.fPaymentFormDialog(event, this.totalPayment, { id: this.loggedinAccountId }, this.feis, false, 0, this.selectedUniqueAccounts).then(function () {
        return _this3.selectedUniqueAccounts.forEach(function (competitor) {
          return _this3.$ngRedux.dispatch((0, _cart.updateCart)(_this3.feis.id, competitor.accountId, true, true));
        });
      });
    }
  }, {
    key: 'updateTotalPayment',
    value: function updateTotalPayment(competitor) {
      if (competitor.selected_for_payment === 1) {
        this.competitors.filter(function (c) {
          return c.accountId === competitor.accountId;
        }).forEach(function (c) {
          return c.selected_for_payment = 1;
        });
        this.totalPayment = (this.totalPayment || 0) + competitor.totalBalance;
        this.selectedUniqueAccounts.push(competitor);
      } else {
        this.competitors.filter(function (c) {
          return c.accountId === competitor.accountId;
        }).forEach(function (c) {
          return c.selected_for_payment = 0;
        });
        this.totalPayment = (this.totalPayment || 0) - competitor.totalBalance;
        this.selectedUniqueAccounts = this.selectedUniqueAccounts.filter(function (a) {
          return a.accountId !== competitor.accountId;
        });
      }
    }
  }]);

  return SchoolCompetitorEventsController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.registrations-for-school', ['ui.router', 'ifeis.common', _ngRedux2.default, 'ifeis.routes.feiseanna.one', 'ifeis.payment-form']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.registrations-for-school', {
    controller: SchoolCompetitorEventsController,
    controllerAs: 'competitors',
    template: require('./tpl.html'),
    url: 'schools/:sid/registrations/:loggedinAccountId',
    ncyBreadcrumb: {
      label: 'Registrations For School',
      parent: function parent($scope) {
        return $scope.hasAnyGrantsForFeis ? 'feiseanna.one.admin.schools.all' : 'feiseanna.one.landing-page';
      }
    }
  });
}).controller('SchoolCompetitorEventsController', SchoolCompetitorEventsController);


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/registrations-for-school/index.js
// module id = 592
// module chunks = 0